<template>
  <div>
    <HeadIndex></HeadIndex>
    <div ref="height_top" class="product-page">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="{ span: 22, offset: 1 }" :xl="{ span: 20, offset: 2 }" class="product-container"
          :style="{ height: tableHeight - 60 + 'px' }">
          <el-row :gutter="20">
            <el-col :lg="11" :md="24" class="gallery-wrapper">
              <div class="main-carousel">
                <el-carousel v-model="activeIndex" height="400px" arrow="hover" indicator-position="none">
                  <!-- 修复：空图判断 -->
                  <el-carousel-item v-if="!data?.img || data.img.length === 0">
                    <div class="empty-img">
                      <el-icon size="48" color="#ccc">
                        <Picture />
                      </el-icon>
                      <span>用户暂未上传图片</span>
                    </div>
                  </el-carousel-item>
                  <el-carousel-item v-for="(item, key) in data.img" :key="key">
                    <el-image :src="item" fit="contain" preview-teleported @preview.open="handlePreview(key)"
                      class="carousel-img" />
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="thumbnail-outer">
                <div class="thumbnail-container" ref="thumbnailContainer">
                  <div class="thumb-item" v-for="(item, key) in data.img" :key="key"
                    :class="{ active: key === activeIndex }" @mouseenter="switchToImage(key)">
                    <el-image :src="item" fit="cover" />
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :lg="13" :md="24" class="info-wrapper">
              <el-tabs v-model="activeName" @tab-change="handleClick" class="info-tabs">
                <el-tab-pane label="商品详情" name="img">
                  <div class="detail-card">
                    <div class="goods-title">
                      <h2>{{ data.brand_name || '' }} {{ data.model || '' }}</h2>
                    </div>

                    <!-- 修复：标签数组容错 -->
                    <div class="tag-group" v-if="data?.stock_type_txt_list?.length">
                      <el-tag v-for="(tag, idx) in data.stock_type_txt_list" :key="idx" :type="getTagType(tag)"
                        size="default">
                        {{ tag }}
                      </el-tag>
                    </div>

                    <el-card class="price-card" shadow="hover">
                      <div class="price-row">
                        <span class="label">单价</span>
                        <span class="price">¥{{ data.tsw_price || '--' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">列表价</span>
                        <span class="text line-through">¥{{ data.price || '--' }}</span>
                        <span class="discount" v-if="data.tsw_discount">{{ data.tsw_discount }}折</span>
                      </div>
                    </el-card>

                    <el-descriptions :column="3" border class="base-info">
                      <el-descriptions-item label="品牌">{{ data.brand_name || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="品名">{{ data.name || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="型号">{{ data.model || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="订货号">{{ data.order_no || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="单位">{{ data.unit || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="备注">{{ data.remark || '无备注' }}</el-descriptions-item>
                    </el-descriptions>

                    <el-divider content-position="left">
                      <span class="contact-title">联系方式</span>
                    </el-divider>
                    <el-descriptions :column="2" border class="contact-info">
                      <el-descriptions-item label="联系人">{{ data.user_linkman || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="联系电话">{{ data.user_mobile || '--' }}</el-descriptions-item>
                      <el-descriptions-item label="所在地区" :span="2">
                        {{ data.user_province_name || '' }} {{ data.user_city_name || '--' }}
                      </el-descriptions-item>
                    </el-descriptions>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="疑似关联" name="list">
                  <template #label>
                    <span>疑似关联
                      <!-- 修复：数组长度容错 -->
                      <el-badge :value="data?.associate?.length || 0" :max="99" type="danger"
                        v-if="data?.associate?.length" />
                    </span>
                  </template>

                  <div class="related-list" style="height:62vh;overflow:auto;">
                    <el-descriptions title="当前商品" border :column="3">
                      <el-descriptions-item label="品牌">{{ data.brand_name || '' }}</el-descriptions-item>
                      <el-descriptions-item label="型号">{{ data.model || '' }}</el-descriptions-item>
                      <el-descriptions-item label="订货号">{{ data.order_no || '' }}</el-descriptions-item>
                    </el-descriptions>

                    <!-- 修复：循环数组容错 -->
                    <div class="related-item" v-for="(item, idx) in (data.associate || [])" :key="idx">
                      <el-descriptions title="" border :column="3" style="margin-top:10px;">
                        <el-descriptions-item label="品牌">{{ item.brand_name || '' }}</el-descriptions-item>
                        <el-descriptions-item label="型号">{{ item.model || '' }}</el-descriptions-item>
                        <el-descriptions-item label="订货号">{{ item.order_no || '' }}</el-descriptions-item>
                        <el-descriptions-item label="备注" :span="3">{{ item.remark || '无' }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div class="footer">
      CopyRight © 脱手网 2018 苏ICP备18008659号
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { Picture } from '@element-plus/icons-vue'
import HeadIndex from '../public/HeadIndex';
export default {
  name: 'product',
  components: { HeadIndex, Picture },
  data() {
    return {
      activeName: 'img',
      activeIndex: 0,
      num: 1,
      tableHeight: '',
      // 初始化默认值，防止页面报错
      data: {
        associate: [],
        img: [],
        stock_type_txt_list: [],
        brand_name: '',
        model: '',
        tsw_price: '',
        price: ''
      },
      id: '',
    }
  },
  mounted() {
    this.tableHeight_fun();
  },
  created() {
    this.id = this.$route.query.id;
    // 增加 ID 为空判断
    if (!this.id) {
      ElMessage.error('商品ID不存在');
      return;
    }
    this.search();
  },
  methods: {
    handleClick() { },
    switchToImage(key) {
      this.activeIndex = key;
      this.$refs.carousel?.setActiveItem(key);
    },
    handlePreview(key) {
      this.activeIndex = key;
    },
    getTagType(tag) {
      if (tag === '二手' || tag === '过保' || tag === '包装破损') return 'warning';
      if (tag === '全新') return 'success';
      return 'primary';
    },
    tableHeight_fun() {
      this.$nextTick(() => {
        const top = this.$refs.height_top.getBoundingClientRect().top;
        this.tableHeight = window.innerHeight - top - 55;
        this.tableHeight = Math.max(this.tableHeight, 550);
      })
    },
    async search() {
      try {
        const res = await this.$axios.post('/api/yunsys.Storage/getonestorage', { id: this.id });

        // 修复：正确判断接口状态
        if (res.data.code !== 0) {
          ElMessage.error(res.data.msg || '获取商品失败');
          return;
        }

        // ✅ 核心修复：这里必须取 res.data.data，不是 res.data
        let data = res.data.data || {};

        // 数组容错处理
        data.img = data.img || [];
        data.associate = data.associate || [];
        data.stock_type_txt_list = data.stock_type_txt ? data.stock_type_txt.split("、") : [];
        data.real_money = this.$bn.multiply(data.sur_num, data.real_price, 4);
        data.real_price = this.$bn.multiply(data.real_price, 1, 4);
        data.tsw_price = this.$bn.multiply(data.tsw_price, 1, 4);
        data.tsw_discount = this.$bn.divide(data.tsw_price, data.price, 4)
        // 赋值给页面数据
        this.data = data;
        document.title = data.model || '商品详情';

      } catch (err) {
        ElMessage.error('网络异常或商品不存在');
        console.error('商品接口报错：', err);
      }
    }
  }
}
</script>



<style scoped>
:deep(.el-input-group__append) {

	background: #ff8a5c;
}
.product-page {
  padding: 20px 0;
  min-height: calc(100vh - 120px);
}

.product-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
}

.main-carousel {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.carousel-img {
  width: 100%;
  height: 400px;
  background: #fafafa;
}

.empty-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  gap: 12px;
}

.thumbnail-outer {
  margin-top: 12px;
}

.thumbnail-container {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 4px 0;
  scrollbar-width: none;
}

.thumbnail-container::-webkit-scrollbar {
  display: none;
}

.thumb-item {
  width: 70px;
  height: 70px;
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s;
  overflow: hidden;
}

.thumb-item.active {
  border-color: #ff8a5c;
  transform: scale(1.05);
}

.info-wrapper {
  display: flex;
  flex-direction: column;
}

.info-tabs {
  flex: 1;
}

.goods-title h2 {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.tag-group {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.price-card {
  background: #fffbf5;
  border-left: 4px solid #ff8a5c;
  margin-bottom: 20px;
  padding: 16px 20px;
}

.price-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.price-row .label {
  font-size: 14px;
  color: #666;
}

.price-row .price {
  font-size: 26px;
  font-weight: bold;
  color: #ff8a5c;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-row .text {
  color: #999;
  font-size: 14px;
}

.info-row .discount {
  color: #ff8a5c;
  font-size: 13px;
  background: #fff2e8;
  padding: 2px 6px;
  border-radius: 4px;
}

.base-info,
.contact-info {
  margin-bottom: 20px;
}

.contact-title {
  font-size: 16px;
  font-weight: 600;
  color: #ff8a5c;
}

.footer {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 13px;
  margin-top: 40px;
}
</style>

<style scoped>
:deep(.el-tabs__item.is-active) {
  color: #ff8a5c !important;
  font-weight: 500;
}

:deep(.el-tabs__active-bar) {
  background-color: #ff8a5c !important;
}
</style>